<template>
  <div>
    <a-tabs default-active-key="1" @change="callback">
      <template v-for="tab in tabs">
        <a-tab-pane :key="tab.key">
          <span slot="tab">
            <a-icon :type="tab.iconType" />
            {{tab.tabName}}
          </span>
          <template v-for="(fileContent,index) in fileInfo[tab.key]">
            <support-table :key="index" :table-name="index" :table-data="fileContent" :table-key="tab.key"/>
          </template>
        </a-tab-pane>
      </template>
    </a-tabs>
  </div>
</template>

<script>
import SupportTableVue from "./SupportTable.vue";
export default {
  components: {
    "support-table": SupportTableVue,
  },
  data() {
    return {
      tabs: [
        {
          key: "1",
          tabName: "安装包",
          iconType: "appstore",
        },
        {
          key: "2",
          tabName: "文档",
          iconType: "file-text",
        },
        {
          key: "3",
          tabName: "操作视频",
          iconType: "video-camera",
        },
      ],
      
    };
  },
  props:{
    fileInfo:Array
  },
  methods: {
    callback(key) {
      console.log(key);
    },
  },
};
</script>